import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../utilities/modalHOC';
import { clearAudioAbbreviations } from './actions';
import {
  createOrUpdateAudioAbbreviation,
  createOrUpdateMultipleAudioAbbreviations,
  deleteAudioAbbreviation,
  getAllAudioAbbreviations,
} from './actionsSagas';
import AudioAbbreviations from './AudioAbbreviations';
import {
  getAudioAbbreviations,
  getIsAudioAbbreviationsImportingLoading,
} from './selectors';

const mapStateToProps = (state) => ({
  audioAbbreviations: getAudioAbbreviations(state),
  isAudioAbbreviationsImportingLoading:
    getIsAudioAbbreviationsImportingLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAllAudioAbbreviations: (search, page, skip, limit) =>
    dispatch(getAllAudioAbbreviations(search, page, skip, limit)),
  clearAudioAbbreviations: () => dispatch(clearAudioAbbreviations()),
  createOrUpdateAudioAbbreviation: (abbreviation) =>
    dispatch(createOrUpdateAudioAbbreviation(abbreviation)),
  createOrUpdateMultipleAudioAbbreviations: (abbreviations) =>
    dispatch(createOrUpdateMultipleAudioAbbreviations(abbreviations)),
  deleteAudioAbbreviation: (abbreviation) =>
    dispatch(deleteAudioAbbreviation(abbreviation)),
});

export default addAbilityToOpenModal(
  connect(mapStateToProps, mapDispatchToProps)(AudioAbbreviations),
);
